<template>
  <div class="md-content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <h1 v-if="isEditMode">
          Edit Shortcut Group v2
        </h1>
        <h1 v-else>
          Create Shortcut Group v2
        </h1>

        <md-progress-bar v-if="isLoading" />
        <md-content
          v-else
          class="block"
        >
          <h3>General info</h3>

          <compact-localized-field
            v-model="shortcut_group.title"
            label="Title"
          />

          <compact-localized-field
            v-model="shortcut_group.description"
            label="Description"
          />

          <compact-localized-field
            v-model="shortcut_group.notice"
            label="Notice"
          />

          <label>Icon</label>
          <string-string-map-input
            :value.sync="shortcut_group.images"
          />

          <localized-c-t-a-form v-model="shortcut_group.cta" />

          <label class="inlineFieldLabel">Access</label>
          <md-field class="field">
            <md-select v-model="shortcut_group.shortcuts_access">
              <md-option value="SHORTCUTS_ACCESS_FREE">
                Free
              </md-option>
              <md-option value="SHORTCUTS_ACCESS_PREMIUM">
                Premium
              </md-option>
            </md-select>
          </md-field>

          <md-switch v-model="shortcut_group.enabled">
            Enabled
          </md-switch>

          <label class="inlineFieldLabel">Sequence Index</label>
          <md-field class="field">
            <md-input v-model="shortcut_group.sequence_index" />
          </md-field>

          <compact-localized-field
            v-model="shortcut_group.read_more"
            label="Read more"
          />
        </md-content>

        <md-content
          v-if="!isLoading"
          class="block"
        >
          <h3>Shortcuts</h3>

          <label class="inlineFieldLabel">Type</label>
          <md-field class="field">
            <md-select v-model="shortcut_group.shortcut_type">
              <md-option value="SHORTCUTS_TYPE_DEFAULT">
                Default
              </md-option>
              <md-option value="SHORTCUTS_TYPE_COUNTRY_PICKER">
                Country
              </md-option>
              <md-option value="SHORTCUTS_TYPE_STREAMING">
                Streaming
              </md-option>
            </md-select>
          </md-field>

          <!--          <md-switch v-model="shortcut_group.shortcut_search">-->
          <!--            Search-->
          <!--          </md-switch>-->
          <br>

          <compact-localized-field
            v-model="shortcut_group.shortcuts_header"
            label="Header"
          />

          <div class="spacer" />

          <label v-if="includedShortcuts.length > 0">Shortcuts</label>
          <label v-else>No shortcuts</label>
          <div v-if="includedShortcuts.length > 0">
            <md-chip
              v-for="s in includedShortcuts"
              :key="s.shortcut.slug"
            >
              <a
                :href="'/shortcuts/v2/edit/' + s.shortcut.id"
                target="_blank"
                rel="noreferrer"
              >{{ s.shortcut.slug }}</a>
            </md-chip>
          </div>
        </md-content>

        <md-content
          v-if="!isLoading"
          class="block"
        >
          <h3>Enhancers</h3>

          <enhancer-picker :selected-enhancers.sync="shortcut_group.enhancers" />
        </md-content>

        <md-content
          v-if="!isLoading"
          class="block"
        >
          <h3>Payload :shrug:</h3>
          <string-string-map-input
            :value.sync="shortcut_group.payload"
          />
        </md-content>

        <div class="buttonLineWrapper">
          <md-button
            v-if="isEditMode"
            class="md-accent deleteButton"
            @click="deleteDialog.isActive = true"
          >
            Delete
          </md-button>

          <md-button
            class="md-primary submitButton"
            @click="handleSubmit"
          >
            Save
          </md-button>
        </div>
      </div>
    </div>

    <md-dialog
      :md-active.sync="previewDialog.isActive"
      class="dialog-wrapper"
    >
      <pre
        style="overflow: scroll"
        v-html="previewDialog.diffView"
      />

      <md-dialog-actions>
        <md-button @click.native="previewDialog.isActive = false">
          Close
        </md-button>
        <md-button
          class="md-primary"
          @click.native="updateShortcutGroup"
        >
          Save
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-confirm
      :md-active.sync="deleteDialog.isActive"
      :md-title="`Delete the '${shortcut_group.title.en || ':shrug:'}' shortcut group?`"
      md-confirm-text="Delete"
      md-cancel-text="Cancel"
      @md-cancel="deleteDialog.isActive = false"
      @md-confirm="deleteGroup"
    />
  </div>
</template>
<script>
import CompactLocalizedField from "../../components/Forms/Fields/CompactLocalizedField";
import StringStringMapInput from "../../components/Forms/Fields/StringStringMapInput";
import LocalizedCTAForm from "../../components/Forms/Fields/LocalizedCTAForm";
import EnhancerPicker from "../../components/Forms/Fields/EnhancerPicker";
import {diff, formatters} from "jsondiffpatch";

export default {
  name: "EditShortcutGroupV2",
  components: {EnhancerPicker, StringStringMapInput, LocalizedCTAForm, CompactLocalizedField},
  data() {
    return {
      isLoading: true,
      isEditMode: !this.$route.path.includes("create"),
      fetchedJSON: {},
      previewDialog: {
        isActive: false,
        diffView: "",
        preparedBody: {}
      },
      deleteDialog: {
        isActive: false
      },

      shortcut_group: {},

      includedShortcuts: []
    };
  },
  mounted() {
    if (this.isEditMode) {
      this.fetchShortcut();
    } else {
      this.initializeEmptyShortcutGroup();
      this.isLoading = false;
    }
  },
  methods: {
    initializeEmptyShortcutGroup() {
      this.shortcut_group = {
        title: {en: "", uk: ""},
        description: {en: "", uk: ""},
        images: {header: "img.png"},
        cta: {
          disconnected: {
            en: "Activate",
            uk: "",
          },
          connecting: {
            en: "Cancel",
            uk: "",
          },
          connected: {
            en: "Deactivate",
            uk: "",
          }
        },
        shortcuts_access: "SHORTCUTS_ACCESS_FREE",
        shortcuts_header: {
          en: "header",
          uk: "головач"
        },
        read_more: {
          en: "string",
          uk: "string"
        },
        shortcuts: [],
        enhancers: [],
        shortcut_type: "SHORTCUTS_TYPE_DEFAULT",
        payload: {},

        enabled: false,
        sequence_index: 0,
        notice: {en: "", uk: ""},

        // missing fields
        shortcuts_search: false,
      };
    },
    fetchShortcut() {
      this.isLoading = true;
      this.$http.get(`/v1/admin/shortcut-group/system/${this.$route.params.id}`)
        .then((res) => {
          const fetchedGroup = res.data.shortcut_group;
          this.fetchedJSON = JSON.parse(JSON.stringify(fetchedGroup));

          this.shortcut_group = res.data.shortcut_group;

          this.isLoading = false;
        })
        .catch(err => {
          console.error(err);
          this.$notify({
            group: "foo",
            title: "Couldn't load group",
          });

          this.isLoading = false;
        });

      this.$http.get(`/v1/admin/system/shortcut-groups/${this.$route.params.id}/shortcuts`)
        .then(res => {
          this.includedShortcuts = res.data.shortcuts;
        });
    },
    handleSubmit() {
      if (this.isEditMode) {
        this.showPreview();
      } else {
        this.createShortcutGroup();
      }
    },
    createShortcutGroup() {
      this.$http.post("/v1/admin/system/shortcut-group/create", {
        shortcut_group: {
          ...this.shortcut_group
        }
      })
        .then(() => {
          this.$notify({
            group: "foo",
            title: "Shortcut Group created",
          });
          window.location.href = "/shortcuts/v2/groups";
        })
        .catch(err => {
          console.error(err);
          this.$notify({
            group: "foo",
            title: "Shortcut Group creation failed: " + err,
          });
          this.loading = false;
        });
    },
    showPreview() {
      this.previewDialog.isActive = true;
      this.previewDialog.preparedBody =  {
        ...this.shortcut_group
      };

      const d = diff(this.fetchedJSON, this.previewDialog.preparedBody);

      this.previewDialog.diffView = formatters.html.format(d, this.fetchedJSON);

      if (this.previewDialog.diffView.length === 0) {
        this.previewDialog.diffView = "No differences found\n\r" + JSON.stringify(this.fetchedJSON, null, 4);
      }
    },
    updateShortcutGroup() {
      this.$http.put("/v1/admin/system/shortcut-group/system/update", {
        shortcut_group: this.previewDialog.preparedBody
      })
        .then(() => {
          this.$notify({
            group: "foo",
            title: "Shortcut Group updated",
          });
          window.location.href = "/shortcuts/v2/groups";
        })
        .catch(err => {
          console.error(err);
          this.$notify({
            group: "foo",
            title: "Shortcut Group creation failed: " + err,
          });
          this.loading = false;
        });
    },
    deleteGroup () {
      this.isLoading = true;
      this.$http.delete(`/v1/admin/shortcut-group/system/delete?shortcut_group_id=${this.$route.params.id}`)
        .then(() => {
          this.$notify({
            group: "foo",
            title: "Shortcut Group deleted",
          });
          window.location.href = "/shortcuts/v2/groups";
        })
        .catch(err => {
          console.error(err);
          this.$notify({
            group: "foo",
            title: "Shortcut Group deletion failed: " + err,
          });
          this.loading = false;
        });
    },
  }
};
</script>
<style scoped lang="scss">
$content-width: 750px;

.block {
  padding: 20px;
  max-width: 750px;

  h3 {
    margin: 0 0 20px;
  }

  & + & {
    margin: 40px 0 0;
  }
}

.inlineFieldLabel {
  display: block;
  margin: 0 0 -20px;
}

.spacer {
  margin: 20px 0 0;
}

.buttonLineWrapper {
  max-width: $content-width;

  display: grid;
  grid-template-columns: [left-col] 100px [right-col] 100px;
  justify-content: space-between;

  .submitButton {
    grid-column-start: right-col;
  }

  .deleteButton {
    background: #ff5252 !important;
  }
}
</style>
